import useTenantsSorting, { TenantsSortingResult } from 'features/tenants/hooks/tenants-sorting';
import useTenantsTable, { TenantsTableResult } from 'features/tenants/hooks/tenants-table';

export type UseTenantsResult = TenantsSortingResult & TenantsTableResult;

const useTenants = (): UseTenantsResult => {
  return {
    ...useTenantsSorting(),
    ...useTenantsTable(),
  };
};

export default useTenants;
